import Axios from "axios"
import { ORG_ALL, ORG_THAILAND } from "../config/CommonConfig"
import { STORAGE_CUSTOM_CONFIG } from "../config/StorageConfig"
import { getStorage } from "./StorageService"

/* eslint-disable */
const getClone = (obj) => JSON.parse(JSON.stringify(obj))
const getNumberWithCommas = val => {
    return val ? val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : "0"
}
const getNumberFixed = (val, digits) => {
    return getNumberWithCommas((val ? val : 0).toFixed(digits))
}
const getPercent = (val, tot) => {
    return tot > 0 ? Math.floor(val ? (val * 100 / tot) : 0) : 0
}
const getPercentHtml = (val, tot) => {
    return tot > 0 ? getNumberWithCommas((val ? (val * 100 / tot) : 0).toFixed(0)) + "%" : "-"
}
const getValWithPercentHtml = (val, tot) => {
    return (val ? getNumberWithCommas(val) : 0) + '<span class="percent">(' + getNumberWithCommas((val ? (val * 100 / tot) : 0).toFixed(0)) + '%)</span>'
}

const numberToShortFormat = (number) => {
    if (number >= 1000000000) {
        return (number / 1000000000).toFixed(1) + 'B';
    } else if (number >= 1000000) {
        return (number / 1000000).toFixed(1) + 'M';
    } else if (number >= 1000) {
        return (number / 1000).toFixed(1) + 'K';
    } else {
        return number.toFixed(1);
    }
}

const isDecimal = (num) => {
    return (num ^ 0) !== num;
}

const convertTime = (value) => {
    const sec = parseInt(value, 10); // convert value to number if it's string
    let hours   = Math.floor(sec / 3600); // get hours
    let minutes = Math.floor((sec - (hours * 3600)) / 60); // get minutes
    let seconds = sec - (hours * 3600) - (minutes * 60); //  get seconds
    // // add 0 if value < 10; Example: 2 => 02
    if (0 < seconds < 60 && hours < 1 && minutes < 1) {return seconds + "s";}
    if (0 < seconds < 60 && hours < 1 && 0 < minutes < 60) {return minutes+'m'+seconds+"s";}
    if (0 < seconds < 60 && 0 < hours < 24 && 0 < minutes < 60) {return hours+'h'+minutes+'m'+seconds+"s";}
}

const getSpan = (innerHtml, className) => {
    return '<span class="' + className + '">' + innerHtml + '</span>'
}

const getCurrentDateStr = () => {
    var today = new Date();
    return today.toISOString().substring(0, 10);
}

const isMobile = () => {
    let check = false;
    (function (a) { if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true; })(navigator.userAgent || navigator.vendor || window.opera);
    return check;
}

const isMobileAndTablet = () => {
    let check = false;
    (function (a) { if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true; })(navigator.userAgent || navigator.vendor || window.opera);
    return check || window.innerWidth <= 980;
}

const isIterable = object => object != null && typeof object[Symbol.iterator] === 'function'

const resetWindow = () => {
    window.scrollTo(0, 0)
    document.getElementsByTagName('body')[0].className = document.getElementsByTagName('body')[0].className.replaceAll(' sb-sidenav-toggled', '')
}

const getRedisDateFormat = (str) => {
    return str
}

const callApi = (apiUrl, apiName) => {
    if (window.confirm("Confirm " + apiName + "?")) {
        Axios.get(apiUrl).then(resp => {
            if (resp && resp.status === 200) {
                alert(apiName + " success.")
            } else {
                alert(apiName + " fail.")
            }
        })
    }
}

const getPageCustomConfig = () => {
    let rslt = {}
    const customConfig = getStorage(STORAGE_CUSTOM_CONFIG)
    const page = window.location.pathname.replaceAll("/", "_")

    if (customConfig && customConfig.page && customConfig.page[page]) {
        rslt = customConfig.page[page]
    }

    return rslt
}

const getPageOrg = () => {
    const pathArr = window.location.pathname.split("/")
    return pathArr[pathArr.length - 1]
}

const getOrg = () => {
    let org = ORG_THAILAND

    ORG_ALL.forEach(cur => {
        window.location.pathname.split("/").forEach(v => {
            if (cur === v) {
                org = cur
            }
        })
    })

    return org
}

const FORMAT_NUMBER_M = "x.xxm"
const getNumberFormat = (opt, val) => {
    let rslt = getNumberFixed(val, 0)

    if (opt === FORMAT_NUMBER_M) {
        rslt = getNumberFixed(val / 1000000, 2) + "m"
    }

    return rslt
}

const padLeft = (val, pre, len) => {
    let rslt = val + ""

    if (val !== "" && pre !== "" && len > 0) {
        while (rslt.length < len) {
            rslt = pre + rslt
        }
    }

    return rslt
}

const getDateFormat = (val, fmt) => {
    const yyyy = padLeft(val.getFullYear(), '0', 4)
    const MM = padLeft(val.getMonth() + 1, '0', 2)
    const dd = padLeft(val.getDate(), '0', 2)
    let rslt = yyyy + MM + dd

    if (fmt === "yyyy-MM-dd") {
        rslt = yyyy + "-" + MM + "-" + dd
    } else if (fmt === "yyyyMMdd") {
        rslt = yyyy + MM + dd
    }

    return rslt
}

const getDateStrFormat = (val, fmt) => {
    let out = ""
    const yyyy = val.substr(0, 4)
    const MM = val.substr(4, 2)
    const dd = val.substr(6, 2)
    const HH = val.substr(8, 2)
    const mm = val.substr(10, 2)
    const ss = val.substr(12, 2)

    if (fmt === "yyyy-MM-dd HH:mm:ss") {
        out = yyyy + "-" + MM + "-" + dd + " " + HH + ":" + mm + ":" + ss
    } else if (fmt === "yyyy-MM-dd HH:mm") {
        out = yyyy + "-" + MM + "-" + dd + " " + HH + ":" + mm
    } else if (fmt === "HH:mm") {
        out = HH + ":" + mm
    }

    return out
}

const getParseDate = (val, fmt) => {
    let yyyy = val.substr(0, 4)
    let MM = val.substr(4, 2)
    let dd = val.substr(6, 2)

    if (fmt === "yyyyMMddHHmmss") {
        return new Date(val.replace(
            /^(\d{4})(\d\d)(\d\d)(\d\d)(\d\d)(\d\d)$/,
            '$4:$5:$6 $2/$3/$1'
        ));
    } else {
        return new Date(yyyy + "-" + MM + "-" + dd)
    }
}

const getTimeUnit = (sec) => {
    let rslt = []
    const min = 60
    const hour = 60 * 60

    if (sec) {
        if (sec > hour) {
            const h = Math.floor(sec / hour)
            rslt.push(h + "h")
            sec = sec % hour
        }

        if (sec > min) {
            const m = Math.floor(sec / min)
            rslt.push(m + "m")
            sec = sec % min
        }

        if (sec > 0) {
            rslt.push(sec + "s")
        }
    }

    return rslt.slice(0, 2).join(" ")
}

const getShortName = (nm) => {
    return nm ? nm.split("@")[0] : ""
}

const sortByName = (a, b) => { return a.name.localeCompare(b.name) }

export {
    getClone
    , getNumberWithCommas
    , getNumberFixed
    , getPercent
    , getPercentHtml
    , getValWithPercentHtml
    , numberToShortFormat
    , isDecimal
    , convertTime
    , getSpan
    , getCurrentDateStr
    , isMobile
    , isMobileAndTablet
    , isIterable
    , resetWindow
    , getRedisDateFormat
    , callApi
    , getPageCustomConfig
    , getPageOrg
    , getOrg

    , FORMAT_NUMBER_M
    , getNumberFormat

    , getDateFormat
    , getDateStrFormat
    , getParseDate
    , getTimeUnit

    , getShortName
    , sortByName
}